import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center pt-24">
      <div className="text-center">
        <div className="font-display text-8xl text-amber-500">404</div>
        <div className="mt-4 font-display text-3xl text-slate-950">The trail ends here.</div>
        <p className="mt-3 text-slate-600">The page you were looking for doesn&apos;t exist.</p>
        <Link to="/" className="inline-block mt-8 px-6 py-3 rounded-full bg-slate-950 text-white hover:bg-slate-800">Take me home →</Link>
      </div>
    </div>
  );
}
